import React, { useEffect, useState, useRef } from "react";
import Switch from '@mui/material/Switch';
import { useNavigate, useLocation } from 'react-router-dom';
import FullscreenLoader from "../../../components/Common/FullscreenLoader.jsx";
import "../../../styles/Auth/order.css";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Typography,
} from '@mui/material';
import { Box, Modal, Button } from '@mui/material';
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import plusIcon from '@iconify/icons-mdi/eye-circle-outline';
import editIcon from '@iconify/icons-mdi/square-edit-outline';
import deleteIcon from '@iconify/icons-mdi/trash-can-outline';
import ViewOrderPopup from './viewOrderPopup.jsx';
import Select from "react-select";
import { getData, uploadFile, postData, deleteData, putData } from '../../../webService/webservice.js';
const OrderPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const isAddOrder = location.pathname === '/orders/add';
    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        textAlign: 'center'
    };
    const headings = [
        "S.No",
        "Order ID",
        "Items",
        "Total Qty",
        "Amount",
        "Payment Status",
        "Order Status",
        "City",
        "Action"
    ];
    const fileInputRef = useRef(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [orderImage, setOrderImage] = useState(null);
    const [orderImages, setOrderImages] = useState([]);
    const [previewUrls, setPreviewUrls] = useState([]);
    const [categories, setCategories] = useState([]);
    const [subcategories, setsubcategories] = useState([]);
    const [orders, setOrders] = useState([]);
    const [viewOrderData, setViewOrderData] = useState(null);
    const [openViewPopup, setOpenViewPopup] = useState(false);
    const [loading, setLoading] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [open, setOpen] = useState(false);
    const sessionToken = sessionStorage.getItem("sessionToken");
    const [searchQuery, setSearchQuery] = useState('');
    const [ordersToDelete, setOrdersToDelete] = useState(null);
    const [limit, setLimit] = useState(20);
    const [isPopupMode, setIsPopupMode] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editOrderId, setEditOrderId] = useState(null);
    const [fileName, setFileName] = useState("");
    const [attributes, setAttributes] = useState('');
    const [attributeErrors, setAttributeErrors] = useState({});
    const [errors, setErrors] = useState({});
    const [loadingPreview, setLoadingPreview] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [orderStatus, setOrderStatus] = useState("");

    const [formData, setFormData] = useState({
        title: '',
        description: '',
        orderType: '',
        orderImageObject: '',
        orderImagesObject: [],
        categoryId: '',
        subCategoryId: '',
        tax: '',
        attributes: [],
    });

    useEffect(() => {
        fetchOrders(currentPage, limit, searchQuery);
    }, [currentPage, limit, refreshKey, searchQuery]);

    const fetchOrders = async (page, limit, searchQuery) => {
        const params = {
            page,
            limit,
            title: searchQuery?.trim() || ""
        }
        try {
            setLoading(true);
            const response = await getData('orders/orders', params, sessionToken);
            const resultsWrapper = response?.data || {};
            
            const ordersList = resultsWrapper.results || [];
            
            const totalCount = resultsWrapper.totalCount || 0;
            const totalPages = Math.ceil(totalCount / (resultsWrapper.limit || 1));

            setOrders(ordersList);
            setTotalCount(totalCount);
            setTotalPages(totalPages);
        } catch (error) {
            toast.error(error.message || "Failed to fetch Orders");
        } finally {
            setLoading(false);
        }
    };

    const openUpdateStatusPopup = (order) => {
        setSelectedOrder(order);
        setOrderStatus(order.orderStatus);
        setIsPopupMode(true);
    };

    const handleUpdateOrderStatus = async (e) => {
        e.preventDefault();

        try {
            const token = sessionStorage.getItem("sessionToken");

            const payload = {
            orderStatus // ✅ only this field
            };

            const response = await postData(
            `orders/update/${selectedOrder._id}`,
            payload,
            token
            );

            toast.success(response.message || "Order status updated");

            setIsPopupMode(false);
            setSelectedOrder(null);

            fetchOrders(currentPage, limit); // refresh list
        } catch (error) {
            console.error(error);
            toast.error("Failed to update order status");
        }
    };

    const handleViewOrder = async (orderId) => {
        try {
            setLoading(true);

            // Assuming sessionToken is from sessionStorage
            const sessionToken = sessionStorage.getItem("sessionToken");

            // Fetch data using your getData function

            const response = await getData(`orders/view/${orderId}`, sessionToken);
            console.log(response);
            // Check if response is already JSON
            const data = response?.order || response;
            
            // Set the view data
            setSelectedOrder(data);
            // setViewOrderData(data);
            setOpenViewPopup(true);
        } catch (error) {
            console.error("Error fetching Order:", error);
            toast.error(error.message || "Failed to fetch Order data");
        } finally {
            setLoading(false);
        }
    };

    const handleOpen = (categoryId) => {
        setOrdersToDelete(categoryId);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setOrdersToDelete(null);
    };

    const triggerRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const params = {};
                const token = sessionStorage.getItem("sessionToken");
                const data = await getData('categories/categories', params, token);
                const results = data?.data?.results?.[0]?.paginatedResults || [];
                setCategories(results);
            } catch (error) {
                console.error("Failed to load categories", error);
            }
        };

        const fetchAttributes = async () => {
            try {
                const token = sessionStorage.getItem("sessionToken");
                const data = await getData('attributes/attributes', {}, token);
                console.log("API Full Response: ", data);
                const results = data?.data?.results?.results || [];
                setAttributes(results);
            } catch (error) {
                console.error("Failed to fetch Attributes", error);
            }
        }

        fetchCategories();
        fetchAttributes();
    }, []);

    useEffect(() => {
        if (!formData.categoryId) {
            setsubcategories([]);
            return;
        }

        const fetchSubCategories = async () => {
            try {
                const token = sessionStorage.getItem("Token");

                const data = await getData(
                    `subcategories/category/${formData.categoryId}`,
                    {},   // NO params needed
                    token
                );

                const results = data?.data?.results?.[0]?.paginatedResults || [];
                setsubcategories(results);

            } catch (error) {
                console.error("Failed to load sub categories", error);
            }
        };

        fetchSubCategories();
    }, [formData.categoryId]);

    const handlePageChange = (direction) => {
        setCurrentPage((prev) =>
            direction === "next" ? Math.min(prev + 1, totalPages) : Math.max(prev - 1, 1)
        );
    };

    const handleItemsPerPageChange = (e) => {
        const value = e.target.value;
        const newLimit = value === "all" ? "all" : Number(value);
        setLimit(newLimit);
        setCurrentPage(1);
    };

    const handleToggle = async (orderId, newStatus) => {
        try {
            const token = sessionStorage.getItem("sessionToken");

            const response = await putData(
                `orders/order/${orderId}`,
                { isActive: newStatus },    // send true or false
                token
            );

            toast.success(response.message || "Status updated!");

            triggerRefresh();
        } catch (error) {
            console.error("Toggle Error:", error);
            toast.error("Failed to update status");
        }
    };

    const handleToggleOnline = async (orderId, newStatus) => {
        try {
            const token = sessionStorage.getItem("sessionToken");

            const response = await putData(
                `orders/order/${orderId}`,
                { isOnline: newStatus },    // send true or false
                token
            );

            toast.success(response.message || "Status updated!");

            triggerRefresh();
        } catch (error) {
            console.error("Toggle Error:", error);
            toast.error("Failed to update status");
        }
    };

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: '#e6cf80',
        borderRadius: 12,
        boxShadow: 24,
        p: 4,
        border: 0
    };

    const validateOrderForm = (formData, orderImage, orderImages) => {
        let errors = {};

        // Order Name
        if (!formData.title?.trim()) {
            errors.title = "Order name is required";
        }

        // Order Type
        if (!formData.orderType) {
            errors.orderType = "Please select a sale type";
        }

        // ⚡ Attribute validation for Online / Both
        if (formData.orderType === "Online" || formData.orderType === "Both") {

            // No attributes added at all?
            if (!formData.attributes || formData.attributes.length === 0) {
                errors.attributes = "At least one attribute is required";
            } else {
                // Validate each attribute row
                formData.attributes.forEach((attr, index) => {

                    // Attribute Name required
                    if (!attr.attributeId) {
                        errors[`attribute_${index}`] = `Attribute ${index + 1}: Please select an attribute`;
                    }

                    // Attribute Values Required
                    if (!attr.values || attr.values.length === 0) {
                        errors[`attribute_values_${index}`] = `Attribute ${index + 1}: Please select at least one value`;
                    }
                });
            }
        }

        // Category
        if (!formData.categoryId) {
            errors.categoryId = "Please select a category";
        }

        // Subcategory
        if (!formData.subCategoryId) {
            errors.subCategoryId = "Please select a subcategory";
        }

        // Tax
        if (!formData.tax) {
            errors.tax = "Tax percentage is required";
        } else if (isNaN(formData.tax) || formData.tax < 0) {
            errors.tax = "Enter a valid tax percentage";
        }

        // Single Main Image
        if (!orderImage) {
            errors.OrderImage = "Main image is required";
        }

        // Gallery images
        if (!orderImages || orderImages.length === 0) {
            errors.OrderImages = "At least one gallery image is required";
        }

        if (orderImages && orderImages.length > 10) {
            errors.OrderImages = "Maximum 10 gallery images allowed";
        }

        return errors;
    };

    const removeGalleryImage = (index) => {
        setLoading(true);
        // Revoke URL to prevent memory leak
        URL.revokeObjectURL(previewUrls[index]);

        // Remove preview and file
        setPreviewUrls(prev => prev.filter((_, i) => i !== index));
        setOrderImages(prev => prev.filter((_, i) => i !== index));
        setLoading(false);
    };


    return (
        <div className="order-layout">
            {loading && <FullscreenLoader />}
            <div className="order-content">
                <main className="order-main">
                    {isAddOrder ? (
                        <div className="add-Order-form">
                            <h3>Add Order</h3>
                            <form className="Order-form">
                                {/* ROW 1 — Order Name, Category */}
                                <div className="Order-form-row">
                                    <div className="Order-form-group full-width">
                                        <label className="input-label">
                                            Order Name<span className="required">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter Order name"
                                            className={`Order-input ${errors.title ? "input-error" : ""}`}
                                            onChange={(e) => setFormData(prev => ({ ...prev, title: e.target.value }))}
                                        />
                                        {errors.title && <p className="error-msg">{errors.title}</p>}
                                    </div>
                                    <div className="Order-form-group">
                                        <label className="input-label">Category<span className="required">*</span></label>
                                        <select
                                            className={`category-input ${errors.categoryId ? "input-error" : ""}`}
                                            value={formData.categoryId}
                                            onChange={(e) =>
                                                setFormData(prev => ({
                                                    ...prev,
                                                    categoryId: e.target.value,
                                                    subCategoryId: "", // reset selection
                                                }))
                                            }
                                        >
                                            <option value="">Select Category</option>
                                            {categories.map(cat => (
                                                <option key={cat._id} value={cat._id}>
                                                    {cat.categoryName}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.categoryId && <p className="error-msg">{errors.categoryId}</p>}
                                    </div>
                                </div>

                                {/* ROW 2 — Subcategory, Tax */}
                                <div className="Order-form-row three-col">                                   

                                    <div className="Order-form-group">
                                        <label className="input-label">Subcategory<span className="required">*</span></label>

                                        <select
                                            className={`category-input ${errors.subCategoryId ? "input-error" : ""}`}
                                            value={formData.subCategoryId}
                                            onChange={(e) =>
                                                setFormData(prev => ({ ...prev, subCategoryId: e.target.value }))
                                            }
                                            disabled={!formData.categoryId} // disable until category selected
                                        >
                                            <option value="">
                                                {formData.categoryId ? "Select Subcategory" : "Select category first"}
                                            </option>

                                            {subcategories.map(sub => (
                                                <option key={sub._id} value={sub._id}>
                                                    {sub.subCategoryName || sub.name}
                                                </option>
                                            ))}
                                        </select>

                                        {errors.subCategoryId && <p className="error-msg">{errors.subCategoryId}</p>}
                                    </div>


                                    <div className="Order-form-group">
                                        <label className="input-label">Tax (%)<span className="required">*</span></label>
                                        <input
                                            type="number"
                                            className={`Order-input ${errors.tax ? "input-error" : ""}`}
                                            placeholder="Enter Tax %"
                                            value={formData.tax}
                                            onChange={(e) => setFormData({ ...formData, tax: e.target.value })}
                                        />
                                        {errors.tax && <p className="error-msg">{errors.tax}</p>}
                                    </div>
                                </div>

                                {/* ROW 3 — Images */}
                                <div className="Order-form-row two-col">
                                    <div className="Order-form-group">
                                        <label className="input-label">Gallery Images<span className="required">*</span></label>
                                        <input
                                            type="file"
                                            multiple
                                            accept="image/*"
                                            className={`Order-input ${errors.OrderImages ? "input-error" : ""}`}
                                            onChange={(e) => {
                                                setLoadingPreview(true);
                                                let files = Array.from(e.target.files || []);

                                                // Safety check: keep only File objects
                                                files = files.filter(f => f instanceof File);

                                                if (files.length === 0) {
                                                    setLoadingPreview(false);
                                                    return;
                                                }

                                                if (files.length > 10) {
                                                    toast.error("Maximum 10 gallery images allowed");
                                                    setLoadingPreview(false);
                                                    return;
                                                }

                                                setOrderImages(files);

                                                setTimeout(() => {
                                                    const previews = files.map((file) => URL.createObjectURL(file));
                                                    setPreviewUrls(previews);
                                                    setLoadingPreview(false);  // 🔥 Stop preview loader
                                                }, 200); 
                                            }}
                                        />
                                        {loadingPreview ? (
                                            <div className="preview-loader">
                                                <div className="spinner"></div>
                                                Loading images...
                                            </div>
                                        ) : (
                                            previewUrls.length > 0 && (
                                                <div className="image-preview-multiple">
                                                    {previewUrls.map((img, index) => (
                                                        <div key={index} className="preview-item">
                                                            <img src={img} alt={`preview-${index}`} />

                                                            <button
                                                                type="button"
                                                                className="remove-image-btn"
                                                                onClick={() => removeGalleryImage(index)}
                                                            >
                                                                ✕
                                                            </button>
                                                        </div>
                                                    ))}
                                                </div>
                                            )
                                        )}
                                        {errors.OrderImages && <p className="error-msg">{errors.OrderImages}</p>}
                                    </div>

                                    <div className="Order-form-group">
                                        <label className="input-label">Main Image<span className="required">*</span></label>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            className={`Order-input ${errors.OrderImage ? "input-error" : ""}`}
                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                setOrderImage(file);
                                                setPreviewUrl(URL.createObjectURL(file));
                                            }}
                                        />
                                        {previewUrl && (
                                            <div className="image-preview">
                                                <img src={previewUrl} alt="Preview" />
                                            </div>
                                        )}
                                        {errors.OrderImage && <p className="error-msg">{errors.OrderImage}</p>}
                                    </div>
                                </div>

                                {/* ROW 4 — Description */}
                                <div className="Order-form-row">
                                    <div className="Order-form-group full-width">
                                        <label className="input-label">Description</label>
                                        <textarea
                                            rows={5}
                                            className="Order-input"
                                            placeholder="Enter order description..."
                                            value={formData.description}
                                            onChange={(e) => setFormData(prev => ({ ...prev, description: e.target.value }))}
                                        />
                                    </div>
                                </div>

                                {/* ROW 5 — Sale Type */}
                                <div className="Order-form-row">
                                    <div className="Order-form-group full-width">
                                        <label className="input-label">Sale Type<span className="required">*</span></label>
                                        <select
                                            className={`category-input ${errors.orderType ? "input-error" : ""}`}
                                            value={formData.orderType}
                                            onChange={(e) =>
                                                setFormData(prev => ({ ...prev, orderType: e.target.value }))
                                            }
                                        >
                                            <option value="">Select Order Type</option>
                                            <option value="Offline">Offline</option>
                                            <option value="Online">Online</option>
                                            <option value="Both">Both</option>
                                        </select>
                                        {errors.orderType && <p className="error-msg">{errors.orderType}</p>}
                                    </div>
                                </div>

                                {/* ROW 6 — Attributes (Separate Full Width Section) */}
                                {(formData.orderType === "Online" || formData.orderType === "Both") && (() => {

                                    // ⭐ Get selected subcategory
                                    const selectedSubcategory = subcategories.find(
                                        s => s._id === formData.subCategoryId
                                    );

                                    // ⭐ Filter only attributes linked with this subcategory
                                    const filteredAttributes = selectedSubcategory
                                        ? attributes.filter(a =>
                                            (selectedSubcategory.attributes || []).includes(a._id)
                                        )
                                        : [];

                                    return (
                                        <div className="attribute-section">

                                            {/* Error Message */}
                                            {errors.attributes && (
                                                <p className="error-msg" style={{ marginBottom: "10px" }}>
                                                    {errors.attributes}
                                                </p>
                                            )}

                                            <div className="attribute-header-row">
                                                <h3 className="attribute-title">Order Attributes</h3>

                                                <button
                                                    type="button"
                                                    className="add-attr-btn"
                                                    onClick={() =>
                                                        setFormData(prev => ({
                                                            ...prev,
                                                            attributes: [
                                                                ...(prev.attributes || []),
                                                                { attributeId: "", values: [] }
                                                            ],
                                                        }))
                                                    }
                                                >
                                                    + Add Attribute
                                                </button>
                                            </div>

                                            {/* Attribute Rows */}
                                            {formData.attributes?.length > 0 && (
                                                <div className="attribute-rows">
                                                    {formData.attributes.map((attr, index) => {

                                                        // ⭐ Selected attribute from filtered list
                                                        const selectedAttr = filteredAttributes.find(a => a._id === attr.attributeId);

                                                        return (
                                                            <div key={index} className="attribute-card-container">

                                                                {/* Remove Row */}
                                                                <span
                                                                    className="attr-remove-icon"
                                                                    onClick={() => {
                                                                        const updated = formData.attributes.filter((_, i) => i !== index);
                                                                        setFormData({ ...formData, attributes: updated });
                                                                    }}
                                                                >
                                                                    ✕
                                                                </span>

                                                                {/* Select Attribute */}
                                                                <label className="input-label">Select Attribute</label>

                                                                <Select
                                                                    options={filteredAttributes.map(a => ({
                                                                        value: a._id,
                                                                        label: a.attributeName,
                                                                    }))}

                                                                    value={
                                                                        attr.attributeId
                                                                            ? {
                                                                                value: attr.attributeId,
                                                                                label:
                                                                                    filteredAttributes.find(a => a._id === attr.attributeId)
                                                                                        ?.attributeName || "",
                                                                            }
                                                                            : null
                                                                    }

                                                                    onChange={(selectedOption) => {
                                                                        const updated = [...formData.attributes];
                                                                        updated[index].attributeId = selectedOption.value;
                                                                        updated[index].values = []; // reset values on attribute change
                                                                        setFormData({ ...formData, attributes: updated });
                                                                    }}

                                                                    placeholder={filteredAttributes.length === 0
                                                                        ? "No attributes linked with this subcategory"
                                                                        : "Select Attribute"
                                                                    }

                                                                    isDisabled={filteredAttributes.length === 0}
                                                                    classNamePrefix="select"
                                                                />

                                                                {errors[`attribute_${index}`] && (
                                                                    <p className="error-msg">{errors[`attribute_${index}`]}</p>
                                                                )}

                                                                {/* Values Multi-Select */}
                                                                {selectedAttr && (
                                                                    <>
                                                                        <label className="input-label mt-2">Select Values</label>

                                                                        <Select
                                                                            isMulti
                                                                            options={
                                                                                selectedAttr.values
                                                                                    ?.filter(v => v.isActive)
                                                                                    ?.map(v => ({
                                                                                        value: v.value,
                                                                                        label: v.value,
                                                                                    }))
                                                                            }

                                                                            value={attr.values.map(v => ({ value: v, label: v }))}

                                                                            onChange={(selectedOptions) => {
                                                                                const updated = [...formData.attributes];
                                                                                updated[index].values = selectedOptions.map(opt => opt.value);
                                                                                setFormData({ ...formData, attributes: updated });
                                                                            }}

                                                                            classNamePrefix="select"
                                                                        />

                                                                        {errors[`attribute_values_${index}`] && (
                                                                            <p className="error-msg">{errors[`attribute_values_${index}`]}</p>
                                                                        )}
                                                                    </>
                                                                )}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            )}

                                        </div>
                                    );
                                })()}


                                {/* FINAL BUTTONS */}
                                {/* <div className="Order-buttons">
                                    <button className="add-Order-button" type="submit" onClick={handleAddOrder}>
                                        Add Order
                                    </button>
                                    <button className="cancel-Order-button" onClick={() => navigate("/orders")}>
                                        Cancel
                                    </button>
                                </div> */}

                            </form>

                        </div>
                    ) : (
                        <>
                            <div className="order-widgets">
                                <div className="order-widgets-header">
                                    <h3>Orders</h3>
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        className="order-search-input"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                </div>
                                <div className="add-order-buttons">
                                    {/* <button
                                        className="add-btn-order"
                                        onClick={() => fileInputRef.current.click()}
                                    >
                                        Bulk Upload
                                    </button>
                                    <input
                                        type="file"
                                        accept=".xlsx, .xls"
                                        style={{ display: "none" }}
                                        ref={fileInputRef}
                                        onChange={handleBulkUploadClick}
                                    /> */}
                                    <button className="add-btn-order" onClick={() => navigate('/orders/add')}>+ Add Order</button>
                                </div>
                            </div>
                            <TableContainer component={Paper} sx={{
                                borderRadius: '12px',
                                maxHeight: 400,
                                overflowY: "auto",
                                '&::-webkit-scrollbar': { display: 'none' },
                                scrollbarWidth: 'none',
                                msOverflowStyle: 'none',
                            }}>
                                <Table className="custom-order-table"
                                    sx={{
                                        '& td, & th': {
                                            border: 'none',
                                        },
                                        border: 'none',
                                    }}>
                                    <TableHead className="custom-order-head">
                                        <TableRow>
                                            {headings.map((heading, index) => (
                                                <TableCell
                                                    key={index}
                                                    sx={{
                                                        border: 'none',
                                                        padding: '12px 16px',
                                                        textAlign: 'center',
                                                        position: "sticky",
                                                        top: 0,
                                                        backgroundColor: '#e6cf80',
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            gap: '4px',
                                                            color: '#000000',
                                                            fontSize: '14px',
                                                            fontWeight: 600,
                                                        }}
                                                    >
                                                        {heading}
                                                    </Typography>
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                    
                                    {orders.length === 0 ? (
                                        <TableRow>
                                        <TableCell colSpan={headings.length}>
                                            <Typography sx={{ textAlign: "center", padding: "20px", fontWeight: 500 }}>
                                            No Orders found.
                                            </Typography>
                                        </TableCell>
                                        </TableRow>
                                    ) : (
                                        orders.map((order, index) => {
                                        const totalQty = order.items.reduce(
                                            (sum, item) => sum + Number(item.quantity || 0),
                                            0
                                        );

                                        return (
                                            <TableRow key={order._id}>
                                            {/* S.No */}
                                            <TableCell align="center">
                                                <Typography sx={commonCellStyle}>
                                                {index + 1}
                                                </Typography>
                                            </TableCell>

                                            {/* Order ID */}
                                            <TableCell align="center">
                                                <Typography sx={commonCellStyle}>
                                                {order.orderId}
                                                </Typography>
                                            </TableCell>

                                            {/* Items Count */}
                                            <TableCell align="center">
                                                <Typography sx={commonCellStyle}>
                                                {order.items.length}
                                                </Typography>
                                            </TableCell>

                                            {/* Total Quantity */}
                                            <TableCell align="center">
                                                <Typography sx={commonCellStyle}>
                                                {totalQty}
                                                </Typography>
                                            </TableCell>

                                            {/* Amount */}
                                            <TableCell align="center">
                                                <Typography sx={commonCellStyle}>
                                                ₹{order.totalAmount}
                                                </Typography>
                                            </TableCell>

                                            {/* Payment Status */}
                                            <TableCell align="center">
                                                <Typography
                                                sx={{
                                                    ...commonCellStyle,
                                                    color:
                                                    order.paymentStatus === "paid"
                                                        ? "green"
                                                        : order.paymentStatus === "failed"
                                                        ? "red"
                                                        : "orange",
                                                    fontWeight: 600
                                                }}
                                                >
                                                {order.paymentStatus}
                                                </Typography>
                                            </TableCell>

                                            {/* Order Status */}
                                            <TableCell align="center">
                                                <Typography
                                                sx={{
                                                    ...commonCellStyle,
                                                    textTransform: "capitalize",
                                                    fontWeight: 600
                                                }}
                                                >
                                                {order.orderStatus}
                                                </Typography>
                                            </TableCell>

                                            {/* City */}
                                            <TableCell align="center">
                                                <Typography sx={commonCellStyle}>
                                                {order.shippingAddress?.city || "-"}
                                                </Typography>
                                            </TableCell>

                                            {/* Action */}
                                            <TableCell align="center">
                                                <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
                                                <Icon
                                                    icon={plusIcon}
                                                    width={20}
                                                    height={20}
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => handleViewOrder(order._id)}
                                                />

                                                <Icon
                                                    icon={editIcon}
                                                    width={20}
                                                    height={20}
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => openUpdateStatusPopup(order)}
                                                />
                                                </Box>
                                            </TableCell>
                                            </TableRow>
                                        );
                                        })
                                    )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <div className="order-bottom">
                                <div className="order-section show-entries">
                                    <span className="text-label">Show</span>
                                    <select className="entries-select" value={limit}
                                        onChange={handleItemsPerPageChange}
                                    >
                                        <option value="20">20</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                        <option value="all">All</option>
                                    </select>
                                    <span className="text-label">Entries</span>
                                </div>
                                <div className="order-section showing-range">
                                    {
                                        limit === 'all'
                                            ? `Showing all ${totalCount} entries`
                                            : `Showing ${(currentPage - 1) * limit + 1} to ${Math.min(currentPage * limit, totalCount)} of ${totalCount} entries`
                                    }
                                </div>
                                <div className="order-section spacer"></div>
                                <div className="order-section pagination-buttons">
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === 1}
                                        onClick={() => handlePageChange("prev")}
                                    >Previous</button>
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === totalPages}
                                        onClick={() => handlePageChange("next")}
                                    >Next</button>
                                </div>
                            </div>
                            {isPopupMode && selectedOrder && (
                            <div className="popup-overlay">
                                <div className="popup-box">

                                <h3>Update Order Status</h3>

                                <form onSubmit={handleUpdateOrderStatus}>

                                    {/* ORDER ID */}
                                    <div className="form-group">
                                    <label>Order ID</label>
                                    <input value={selectedOrder.orderId} disabled />
                                    </div>

                                    {/* ORDER STATUS */}
                                    <div className="form-group">
                                    <label>Order Status</label>
                                    <select
                                        value={orderStatus}
                                        onChange={(e) => setOrderStatus(e.target.value)}
                                        required
                                    >
                                        <option value="pending">Pending</option>
                                        <option value="placed">Placed</option>
                                        <option value="packed">Packed</option>
                                        <option value="shipped">Shipped</option>
                                        <option value="out-for-delivery">Out for Delivery</option>
                                        <option value="delivered">Delivered</option>
                                        <option value="cancelled">Cancelled</option>
                                    </select>
                                    </div>

                                    {/* ACTIONS */}
                                    <div className="form-actions">
                                    <button type="submit" className="btn-primary">
                                        Update
                                    </button>
                                    <button
                                        type="button"
                                        className="btn-secondary"
                                        onClick={() => setIsPopupMode(false)}
                                    >
                                        Cancel
                                    </button>
                                    </div>

                                </form>
                                </div>
                            </div>
                            )}
                            {limit > 5 && orders.length > 5 && (
                                <div className="scroll-down-hint">
                                    <Typography sx={{ display: 'flex', justifyContent: 'center', marginTop: 2, fontSize: 14, fontWeight: 600 }}>
                                        Scroll down to see more Orders
                                    </Typography>
                                </div>
                            )}
                            <Modal
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                            >
                                <Box sx={modalStyle}>
                                    <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ textAlign: 'center' }}>
                                        Confirm Delete?
                                    </Typography>
                                    <Typography id="modal-modal-description" sx={{ mt: 1, fontSize: 14, textAlign: 'center' }}>
                                        Are you sure you want to delete this Order?
                                    </Typography>

                                    {/* <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 3 }}>
                                        <Button variant="contained" color="error" sx={{ background: "#8D2629 " }} onClick={handleDeleteOrder}>
                                            Yes, Delete
                                        </Button>
                                        <Button variant="outlined" color="error" onClick={handleClose} sx={{ background: 'background-color: #D9D9D9', color: '#000' }}>
                                            Cancel
                                        </Button>
                                    </Box> */}
                                </Box>
                            </Modal>
                            {/* {openViewPopup && (
                                <ViewOrderPopup
                                    data={viewOrderData}
                                    onClose={() => setOpenViewPopup(false)}
                                />
                            )} */}
                            {selectedOrder && (
                            <ViewOrderPopup
                                order={selectedOrder}
                                onClose={() => setSelectedOrder(null)}
                            />
                            )}

                        </>
                    )}

                </main >
            </div >
        </div >
    );
};

export default OrderPage;